import React from "react";

const FileInput=({onImageSelected, children})=>{
    const openFileInput=()=>{
        document.getElementById("image-file-selector").click();
    }

    const onInputChange=(event)=>{          
        if(event.target.files){
            let fileToLoad = event.target.files[0];             
            if(!fileToLoad || !fileToLoad.type.includes('image')){
                return;
            }            
            var fileReader = new FileReader();
            fileReader.onload =(fileLoadedEvent)=>{
                let image = fileLoadedEvent.target.result; // <--- data: base64                 
                let base64_image_data = image.split(',')[1];                 
                onImageSelected(image, base64_image_data);                 
            }
            fileReader.readAsDataURL(fileToLoad);
        }
    }

    return (
        <div onClick={openFileInput}>
            <input style={{display:"none"}} id="image-file-selector" type="file" accept="image/*" onChange={onInputChange} />
            {children}
        </div>
    )
}

export default FileInput;